import AssociationView from '@bingads-webui-static-legacy/bulk-edit/view/label/association';
import { showError as error, showSuccess as success } from '@bingads-webui-component-legacy/toast/index';
import template from '@bingads-webui-static-legacy/bulk-edit/template/label/association.pug';
import globalConfig from '@bingads-webui-component-legacy/config/index';
import { getLoadDirectlyLinkedAccounts } from '@bingads-webui-component-legacy/bingads-grid/service/linked-accounts-preferences';

const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
const permissions = globalConfig.get('permissions');

export class LabelAssociationView extends AssociationView {
  initialize({
    el,
    stats,
    selectionInfo,
    grid,
    isForVNext,
    gridName,
    disableDeselectAll = false,
    isManagementRequest = undefined,
  }) {
    this.selectionInfo = selectionInfo;
    this.grid = grid;
    this.disableDeselectAll = disableDeselectAll;
    const loadDirectlyLinkedAccountsObj = getLoadDirectlyLinkedAccounts(gridName);
    const loadDirectlyLinkedAccountsValue = loadDirectlyLinkedAccountsObj ? loadDirectlyLinkedAccountsObj.loadDirectlyLinkedAccounts : 'false';
    const loadDirectlyLinkedAccounts = loadDirectlyLinkedAccountsValue === true || loadDirectlyLinkedAccountsValue === 'true' ? 'true' : 'false';

    const options = {
      el,
      template,
      entity: this.selectionInfo.entityType,
      stats,
      onOperationSuccess: this.onOperationSuccess(this.selectionInfo.selectedRowCount),
      onOperationFailure: () => error(i18nGlobal.getString('label_association_error')),
      grid,
      isForVNext,
      loadDirectlyLinkedAccounts,
    };

    if (permissions && permissions.IsAccountLabelsEnabled && this.selectionInfo.entityType === 'Account') {
      options.scope = 'Customer';
      options.isManagementRequest = isManagementRequest;
    }
    super.initialize(options);
  }

  render() {
    if (this.selectionInfo.allPages) {
      this.ko_model.showProgress(true);
      this.ko_model.showButtonBar(false);
    } else {
      this.ko_model.showPanel = false;
    }
    this.renderBulkEditJobView();
    this.submitJob();
    return this;
  }

  onOperationSuccess(num) {
    return () => {
      success(i18nGlobal.getString('label_association_success', num));
      if (!this.disableDeselectAll) {
        if (this.grid.pgridPlugins && this.grid.pgridPlugins.crossPageSelectAll) {
          this.grid.pgridPlugins.crossPageSelectAll.deselectAll();
        } else {
          this.grid.gridView.deselectAll();
        }
      }
    };
  }
}
